import { Skeleton } from "@/components/ui/skeleton";

export const PaymentDetailsSkeleton = () => (
  <div
    role="status"
    aria-label="Loading payment details"
    className="w-full bg-white rounded-2xl border border-border p-5 shadow-xs space-y-6"
  >
    <div className="flex items-start justify-between gap-3">
      <div className="flex items-start gap-3 min-w-0 flex-1">
        <Skeleton className="h-10 w-10 rounded-full" />
        <div className="space-y-2 min-w-0 flex-1">
          <Skeleton className="h-5 w-40" />
          <Skeleton className="h-3 w-24" />
        </div>
      </div>
      <div className="flex flex-col items-end gap-2 shrink-0">
        <Skeleton className="h-7 w-28" />
        <Skeleton className="h-5 w-20 rounded-full" />
      </div>
    </div>

    <div className="space-y-3">
      <Skeleton className="h-3 w-20" />
      <Skeleton className="h-14 w-full rounded-lg" />
      <Skeleton className="h-3 w-32" />
    </div>

    <div className="space-y-3">
      <Skeleton className="h-3 w-20" />
      <Skeleton className="h-24 w-full rounded-lg" />
    </div>
  </div>
);
